import settings from './settings';
import candidate from './candidate';

const modules = { settings, candidate };

export default modules;
